export const MtsDateFormate = {
        // parseInput: 'DD/MM/YYYY HH:mm',
        fullPickerInput: 'DD/MM/YYYY HH:mm',
        datePickerInput: 'DD/MM/YYYY HH:mm',
        timePickerInput: 'HH:mm',
        monthYearLabel: 'DD/MM/YYYY HH:mm',
        dateA11yLabel: 'DD/MM/YYYY HH:mm',
        monthYearA11yLabel: 'DD/MM/YYYY HH:mm',
    };